import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { translate } from 'react-i18next'
import { compose, pure, withHandlers } from 'recompose'
import styles from './tosForm.scss'
import { actionCreators as sagaActionCreators } from '../../redux/sagas/index'
import { actionCreators as loginActionCreators } from '../../redux/reducers/login/loginReducer'
import { actionCreators as uiActionCreators } from '../../redux/reducers/ui/uiReducer'
import CustomCheckmark from '../components/customCheckmark/customCheckmarkComponent'
import PropTypes from 'prop-types'

const required = value => (value ? undefined : 'isRequired')

export function TosForm (props) {
  const { t, handleSubmit } = props
  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <header>
        <h1 className={styles.modalHeader}>
          {t('form:updatedDocsHeader')}
          <small>
            {t('form:toProceed')}
          </small>
        </h1>
      </header>
      {props.tosDocs.map((doc, index) =>
        <div className={styles.formGroup} key={index}>
          <p>
            <a href={doc.url} target='_blank'>
              {t(`form:${doc.type}`)}
            </a>{' '}
            {t('form:hasBeenUpdated')}
          </p>
          <Field
            name={`input${index}`}
            component={CustomCheckmark}
            type='checkbox'
            id={`input${index}`}
            validate={required}
            label={t(`form:accept`) + ' ' + t(`form:${doc.type}`)}
          />
        </div>
      )}
      <button type='submit'>Submit</button>
      <button type='button' onClick={props.cancelClick}>
        Decline
      </button>
    </form>
  )
}
TosForm.propTypes = {
  tosDocs: PropTypes.array,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  cancelClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

const handlers = {
  onSubmit: props => values => {
    props.acceptDocs(props.tosDocs)
  },
  cancelClick: props => () => {
    props.logout()
    props.toggleTosModal()
  }
}

const boundActions = {
  acceptDocs: sagaActionCreators.authActionCreators.acceptDocs,
  logout: loginActionCreators.reset,
  toggleTosModal: uiActionCreators.toggleTosModal
}

const mapStateToProps = (state, props) => {
  return {
    tosDocs: state.login.unsignedDocs
  }
}

export default compose(
  pure,
  translate(),
  reduxForm({
    form: 'tos'
  }),
  connect(mapStateToProps, boundActions),
  withHandlers(handlers)
)(TosForm)



// WEBPACK FOOTER //
// ./src/forms/tos/tosForm.js